export default __webpack_public_path__ + "magnifying-glass.png";